import { useNavigate } from "react-router-dom";
import { Activity, HeartHandshake, Monitor, Mic } from "lucide-react";
import MassagemIcon from "../../assets/images/icons/massagem.svg";
import YogaIcon from "../../assets/images/icons/yoga.svg";
import HomeIcon from "../../assets/images/icons/home.svg";
import WorkshopIcon from "../../assets/images/icons/workshop.svg";
import RelatorioIcon from "../../assets/images/icons/relatorio.svg";
import QuickIcon from "../../assets/images/icons/quick.svg";
import quickImage from "../../assets/images/solutions/quick.png";
import massagemImage from "../../assets/images/solutions/massagem.png";
import groupImage from "../../assets/images/solutions/group.png";
import workshopImage from "../../assets/images/solutions/workshop.png";
import homeImage from "../../assets/images/solutions/home.png";
import relatorioImage from "../../assets/images/solutions/relatorio.png";
import "./MainSolutions.scss";

const solutions = [
  {
    title: "Massagens e Terapias Individuais",
    image: massagemImage,
    icon: <img src={MassagemIcon} alt="Massagem" className="main-solutions__icon" />,
    route: "/solutions/massagens-terapias-individuais",
    sectionId: "massagens-terapias-individuais",
  },
  {
    title: "Atividades em Grupo e Rotinas de Descompressão",
    image: groupImage,
    icon: <img src={YogaIcon} alt="Yoga" className="main-solutions__icon" />,
    route: "/solutions/yoga-laboral-atividades-grupo",
    sectionId: "yoga-laboral-atividades-grupo",
  },
  {
    title: "Quick Massage e Eventos Corporativos",
    image: quickImage,
    icon: <img src={QuickIcon} alt="Quick Massage" className="main-solutions__icon" />,
    route: "/solutions/quick-massage-eventos-corporativos",
    sectionId: "quick-massage-eventos-corporativos",
  },
  {
    title: "Bem-Estar no Home Office",
    image: homeImage,
    icon: <img src={HomeIcon} alt="Home Office" className="main-solutions__icon" />,
    route: "/solutions/atendimento-online-home-office",
    sectionId: "atendimento-online-home-office",
  },
  {
    title: "Workshops e Palestras",
    image: workshopImage,
    icon: <img src={WorkshopIcon} alt="Workshop" className="main-solutions__icon" />,
    route: "/solutions/workshops-palestras-corporativas",
    sectionId: "workshops-palestras-corporativas",
  },
  {
    title: "Gestão do Programa",
    image: relatorioImage,
    icon: <img src={RelatorioIcon} alt="Relatório" className="main-solutions__icon" />,
    route: "/solutions/relatorios-gestao-programa",
    sectionId: "relatorios-gestao-programa",
  },
];

const MainSolutions = () => {
  const navigate = useNavigate();

  return (
    <section className="main-solutions" id="solutions">
      <div className="main-solutions__inner" data-aos="fade-up">
        <h2>Principais Soluções</h2>

        <div className="main-solutions__grid">
          {solutions.map((item) => (
            <div key={item.title} className="main-solutions__item" data-aos="fade-up">
              <div
                className="main-solutions__image"
                style={{ backgroundImage: `url(${item.image})` }}
              />

              <div className="main-solutions__card">
                <div className="main-solutions__icon-wrapper">{item.icon}</div>
                <h3>{item.title}</h3>
                <button
                  type="button"
                  className="main-solutions__button"
                  onClick={() => navigate(item.route)}
                >
                  Saiba mais
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MainSolutions;
